import React, { useState } from "react";
import "./CoaToShowroom.css";
import { useLicense } from "../../context/licenseContext";
import { useToast } from "../../context/toastContext";
import { useConfirm } from "../../context/confirmContext";
import apiClient from "../../api/apiClient";

const CoaToShowroom = ({ coa, productId, setPublishTab, fetchCoas }) => {
    const { currentLicense } = useLicense();
    const toast = useToast();
    const confirm = useConfirm();
    const [productName, setProductName] = useState(coa.product_name);
    const [price, setPrice] = useState("");
    const [priceUnit, setPriceUnit] = useState("g");
    const [publishing, setPublishing] = useState(false);

    async function triggerAddToShowroom() {
        const accepted = await confirm({
            title: "Publish to Marketplace",
            message: "Publish this product to the DYC Marketplace?",
            confirmLabel: "Publish",
            variant: "primary",
        });
        if (!accepted) return;

        const parsedPrice = price !== "" ? parseFloat(price) : null;
        const data = {
            product_name: productName,
            industry: currentLicense?.industry || "",
            product_id: productId,
            price: parsedPrice,
            price_unit: priceUnit,
        };
        setPublishing(true);
        try {
            await apiClient.post(`/showroom/add-to-showroom`, data);
            toast.success("Published to marketplace.");
            setPublishTab(false);
            fetchCoas();
        } catch (err) {
            toast.error(err.response?.data?.error || err.userMessage || "Failed to publish.");
        } finally {
            setPublishing(false);
        }
    }

    return (
        <div
            className="coa-to-showroom fade-in"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className="coa-to-showroom-content">
                <div className="coa-to-showroom-title">Just a few things before others can see your product</div>
                <div
                    className="coa-to-showroom-close"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setPublishTab(false);
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </div>
                <div className="coa-to-showroom-content-container">
                    <label className="coa-to-showroom-label">Product Name</label>
                    <input
                        type="text"
                        className="coa-to-showroom-product-name"
                        value={productName}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        onChange={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setProductName(e.target.value);
                        }}
                    />
                    <label className="coa-to-showroom-label">Price</label>
                    <div className="coa-to-showroom-price-row">
                        <input
                            type="number"
                            className="coa-to-showroom-price-input"
                            placeholder="0.00"
                            value={price}
                            min="0"
                            step="0.01"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            onChange={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation();
                                setPrice(e.target.value);
                            }}
                        />
                        <select
                            className="coa-to-showroom-unit-select"
                            value={priceUnit}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                                e.stopPropagation();
                                setPriceUnit(e.target.value);
                            }}
                        > 
                            <option value="g">/ g</option>
                            <option value="oz">/ oz</option>
                            <option value="lb">/ lb</option>
                            <option value="unit">/ unit</option>
                            <option value="mg_thc">/ mg THC</option>
                        </select>
                    </div>
                    <div className="coa-to-showroom-buttons">
                        <button
                            className="coa-to-showroom-button add-to"
                            disabled={publishing}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                triggerAddToShowroom();
                            }}
                        >
                            {publishing ? "Publishing..." : "Add to Marketplace"}
                        </button>
                        <button
                            className="coa-to-showroom-button cancel-to"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setPublishTab(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoaToShowroom;
